exports.default = {
  'membership_promotion': 'Membership Promotion',
  'page_under_development': 'This page is currently under active development, stay tuned!'
}
